import { render, staticRenderFns } from "./JobAdmin.vue?vue&type=template&id=fef06cc0&scoped=true"
import script from "./JobAdmin.vue?vue&type=script&lang=js"
export * from "./JobAdmin.vue?vue&type=script&lang=js"
import style0 from "./JobAdmin.vue?vue&type=style&index=0&id=fef06cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef06cc0",
  null
  
)

export default component.exports